import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import stripebadge from '../assets/stripebadge.png';

import { Typography, Paper, Button } from '@material-ui/core'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { RestComponent, StripeManager } from 'react-frontend-utils'


/**
 * 
 * Checkout Component after Patron submits an Application that requires payment 
 * 
 * The caller must pass the props:
 * 
 * returnToApplication:         a function to be called to go back to modify the Application
 * purchaseComplete:            callback function when payment succeeds
 * paymentDescription:          String describing the payment (for instance the amount)
 * clientSecret:                the clientSecret retrieved from the backend from Stripe, after Application is submitted
 * email:                       pre-populate the email for the credit card
 * purchaseNote:                String describing the purchase
 * 
 * The StripeManager component takes care of the purchase. 
 *
 */

const STALE_TIME = 24 * 3600 * 1000;  //24 hours to complete payment

export class PatronCheckout extends RestComponent {

    styles = {
        paperLabel: {
            color: 'blue',
            fontSize: '12pt',
            flexGrow: 1
        }
    }
        
    _submitDate;

    constructor(props) {
        super(props);
        this._submitDate = Date.now();
    }    

    render() {

        const maxTimeToPay = this._submitDate + STALE_TIME;
        
        return (
            <Fragment>

                {this.getConfirmAlertComponent()}

                <Paper style={{padding: 20}}>

                    <Typography variant="h6" align='center' style={{marginBottom: this.props.purchaseNote ? 10 : 40}}>{this.props.paymentDescription}</Typography>                           

                    {this.props.purchaseNote ?
                        <Typography variant="body1" align='center' style={{marginBottom: 40, fontStyle: 'italic'}}>{this.props.purchaseNote}</Typography> 
                        :
                        null
                    }                          

                    <Button color="primary" style={{marginBottom: 20}} onClick={this.props.returnToApplication}>
                        <ArrowBackIosIcon fontSize='small'/> 
                        <Typography variant="body1">Cancel and Go Back to Application</Typography>   
                    </Button>  
        
                            
                    <StripeManager  email={this.props.email}
                                    clientSecret={this.props.clientSecret}
                                    paymentSuccess={this.props.purchaseComplete}
                                    maxTimeToPay={maxTimeToPay}/>

                </Paper>

                <div style={{display: 'flex', justifyContent: 'center', marginTop: 100}}>

                    <a href="https://www.stripe.com" target="_blank" rel="noopener noreferrer">
                        {<img src={stripebadge} alt="stripe badge" width='400px'/>}
                    </a>

                </div>                

            </Fragment>
        );
    }

}

export default withCookies(PatronCheckout);
